// Single DB-driven source of chapter lists (mirrors GET /api/chapters).
import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const DEFAULT_CHAPTERS = {
  active: ["National", "AD", "HS"],
  inactive: ["HA"],
};

let cached = null;
let inflight = null;

export function clearChaptersCache() {
  cached = null;
}

function fetchChapters() {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    const token = localStorage.getItem("token");
    inflight = fetch(`${BACKEND_URL}/api/chapters`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.active) {
          cached = { active: data.active, inactive: data.inactive || [] };
        }
        return cached;
      })
      .catch(() => null)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function useChapters() {
  const [chapters, setChapters] = useState(cached || DEFAULT_CHAPTERS);
  useEffect(() => {
    let alive = true;
    fetchChapters().then((c) => {
      if (alive && c) setChapters(c);
    });
    return () => {
      alive = false;
    };
  }, []);
  return chapters;
}
